/**
 * @deprecated
 * Kept for backwards compatibility. Use {@link AveTypes} instead.
 *
 * Some IDEs have issues with auto importing for re-exported modules.
 * Nevertheless, they still can be imported as usual in client modules, e.g.
 * ```ts
 * import { AnimationDirection } from "@ave2cloud/jetstream/dist/src/types";
 * ```
 */
export { AnimationDirection, CameraMode, ImageFormat, } from "@org-avp/ave-message-factory/src/model";
export var AveMode;
(function (AveMode) {
    AveMode["CLOUD"] = "CLOUD";
    AveMode["LOCAL"] = "LOCAL";
})(AveMode || (AveMode = {}));
/**
 * Status Codes returned by the WebSocket connection to JetStream
 */
export var JetstreamWebsocketStatusCode;
(function (JetstreamWebsocketStatusCode) {
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["TRY_AGAIN_LATER"] = 1013] = "TRY_AGAIN_LATER";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["CLIENT_REQUESTED_CLOSE"] = 4000] = "CLIENT_REQUESTED_CLOSE";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["INVALID_SESSION_ID"] = 4001] = "INVALID_SESSION_ID";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["REQUESTING_ICE_SERVERS_FAILED"] = 4002] = "REQUESTING_ICE_SERVERS_FAILED";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["UNSUPPORTED_MESSAGE_TYPE"] = 4004] = "UNSUPPORTED_MESSAGE_TYPE";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["TERMINATE_MULTI_SESSION"] = 4005] = "TERMINATE_MULTI_SESSION";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["INACTIVITY_TIMEOUT"] = 4006] = "INACTIVITY_TIMEOUT";
    JetstreamWebsocketStatusCode[JetstreamWebsocketStatusCode["WEBSOCKET_CONNECTION_FAILED"] = 4007] = "WEBSOCKET_CONNECTION_FAILED";
})(JetstreamWebsocketStatusCode || (JetstreamWebsocketStatusCode = {}));
//# sourceMappingURL=types.js.map